const dark = {
  '--blue': '#383a59',
  '--green': '#6272a4',
  '--red': '#ad273f',
  '--background': '#282a36',
  '--background-input': '#282a36',
  '--background-lighter': '#272830',
  '--shapes': '#44475a',
  '--text-title': '#f8f8f2',
  '--text': '#f8f8f2',
  '--text-light': '#f8f8f2',
  '--theme-active': '#44475A',
};

const light = {
  '--blue': '#273FAD',
  '--green': '#3FAD27',
  '--red': '#ad273f',
  '--background': '#EBEBEB',
  '--background-input': '#fff',
  '--background-lighter': '#f5f5ff',
  '--shapes': '#FFFFFF',
  '--text-title': '#3D3D4D',
  '--text': '#1C1C29',
  '--text-light': '#A09CB1',
  '--theme-active': '#EBEBEB',
};

export default {
  dark,
  light,
};
